import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import "./pyment.scss"

const SuccessfulPayment = (props) => {
    const {id}=props.match.params;
    return (
        <div className='payment'>
            <div className='payment__box' style={{textAlign:'center'}}>
                <CheckCircleIcon className='success'/><br/>
                <h1>پرداخت موفقیت آمیز</h1>
                <hr/>
                <h4>شناسه پرداخت: {id}</h4>
            </div>
        </div>
    );
};

export default SuccessfulPayment;
